import React from "react";
import { Box, styled, CircularProgress } from "@mui/material";
import { COLOR_CONSTANTS, TYPOGRAPHY_SCALE } from "../../constants/styles";
import { SPACING_CONSTANTS } from "../../constants/styles/spacing";

interface LoadingContentProps {
  /**
   * 로딩 텍스트
   */
  text?: string;
}

const StyledLoadingContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: `${SPACING_CONSTANTS.spacing[1]}px`, // 4px
});

const StyledLoadingText = styled(Box)({
  ...TYPOGRAPHY_SCALE.body2,
  color: COLOR_CONSTANTS.text.disabled,
  fontWeight: 500,
});

/**
 * 로딩 상태를 표시하는 컴포넌트
 * DataCell.Right에서 사용
 */
export const LoadingContent: React.FC<LoadingContentProps> = ({ 
  text = "Loading" 
}) => {
  return (
    <StyledLoadingContainer>
      <CircularProgress size={16} sx={{ color: COLOR_CONSTANTS.text.disabled }} />
      <StyledLoadingText>{text}</StyledLoadingText>
    </StyledLoadingContainer>
  );
};

export type { LoadingContentProps };
